import React from "react";
import "../assets/css/Home.css";
import banner from "../assets/images/banner .png";
import all_steps from "../assets/images/steps-all-new.png";
import BackUp_network from "../assets/images/backup-network.png";
import step2 from "../assets/images/step-2.png";
import step3 from "../assets/images/step-3.png";
import Footer from "./Footer";
const MainBody = () => {
  return (
    <>
    <div className="main-banner">
      <div className="container">
        <div className="text-center landing-page custom-main-hero">
          <div className="custom-main-inner">
            <div className="col-md-6 main-hero-content">
              <div>
                <h1 className="svg-heading">
                  <span>Backup Meraki</span>
                </h1>
              </div>
              <div>
                <h2>
                  <span className="online-tool">
                    Elegant and easy online tool to back up and restore your
                    Cisco Meraki configuration.
                  </span>
                </h2>
              </div>
              <div>
                <p>
                  Accidental or malicious configuration changes can disrupt your
                  network operations. Our solution offers automated, regular
                  backups of your Meraki Dashboard settings, ensuring you can
                  quickly restore configurations when needed. With secure
                  storage and easy retrieval, you gain peace of mind knowing
                  your network is safeguarded against unexpected issues.
                </p>
              </div>
              <div className="banner-btn">
                <button className="btn main-btn" type="button" onClick={() => { window.open("https://app.backupmeraki.com/register", "_blank", "noopener,noreferrer"); }}>
                  Get Started
                </button>
              </div>
            </div>
            <div className="col-md-6 main-pict">
              <img src={banner} alt="Logo" />
            </div>
          </div>
        </div>
      </div>
   </div>
      {/* ----------------------------center-content------------------------------- */}
      <div className="second-dashbord">
        <div className="container meraki-second">
          <div className="text-center">
            <h2 className="second-sect">
              <span>Better safe than sorry.</span>
            </h2>
            <p className="para-same">
              Why back up your Cisco Meraki Dashboard configuration?
            </p>
          </div>
          <div className="cisco-sec ">
            {/* Left side section */}
            <div className="col-md-5 first-left">
              {/* left sectin step 1 image */}
              <div>
                <img src={BackUp_network} alt="backupImage" />
              </div>
              {/* left sectin step to content */}
              <div className="warpping-both restore-sect mobile-case">
                <h5 className="missoon-head">
                  Restore your mission-critical network environment in minutes
                </h5>
                <div className="network-idea">
                  <div className="d-flex">
                    <div>
                      <svg
                        preserveAspectRatio="xMidYMid meet"
                        data-bbox="1.458 1.737 21.089 20.529"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="1.458 1.737 21.089 20.529"
                        height="24"
                        width="24"
                        data-type="color"
                        role="presentation"
                        aria-hidden="true"
                        aria-label=""
                      >
                        <g>
                          <path
                            fill="#71C55D"
                            d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                            data-color="1"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <div>
                      <p>
                        Prepare for the unexpected. Recover from unintended
                        changes or misconfigurations with a few clicks.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        Get back on track quickly. Restore your entire
                        configuration or just the parts you need — no guesswork,
                        no delays.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        Stay operational. Ensure business continuity without
                        scrambling for solutions.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
               <div className="warpping-both desktop-case-bt">
                <h5 className="missoon-head">
                  Backup your critical network configuration
                </h5>
                <div className="network-idea">
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        Accidents happen. Back up your Cisco Meraki Dashboard to
                        protect against unintended changes and ensure peace of
                        mind.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        No built-in rollback? No problem. While the Meraki
                        Dashboard offers powerful management, it doesn't include
                        a built-in rollback option - having a backup ensures
                        you're always prepared for the unexpected.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        Take control of your network. Your settings are your
                        responsibility — back them up to keep your network
                        secure and intact.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* step 3 image */}
              <div className="first-left ">
                <img src={step3} alt="step-3" />
              </div>
            </div>
            {/* center steps image  */}
            <div className="col-md-1 step-pict">
              <img src={all_steps} alt="step" />
            </div>
            {/* right section  */}
            <div className="col-md-5 right-third">
              {/* right section step 1 heading content */}
              <div className="warpping-both mob-case-bt">
                <h5 className="missoon-head">
                  Backup your critical network configuration
                </h5>
                <div className="network-idea">
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        Accidents happen. Back up your Cisco Meraki Dashboard to
                        protect against unintended changes and ensure peace of
                        mind.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        No built-in rollback? No problem. While the Meraki
                        Dashboard offers powerful management, it doesn't include
                        a built-in rollback option - having a backup ensures
                        you're always prepared for the unexpected.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        Take control of your network. Your settings are your
                        responsibility — back them up to keep your network
                        secure and intact.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
                <div className="warpping-both restore-sect desktop-case">
                <h5 className="missoon-head">
                  Restore your mission-critical network environment in minutes
                </h5>
                <div className="network-idea">
                  <div className="d-flex">
                    <div>
                      <svg
                        preserveAspectRatio="xMidYMid meet"
                        data-bbox="1.458 1.737 21.089 20.529"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="1.458 1.737 21.089 20.529"
                        height="24"
                        width="24"
                        data-type="color"
                        role="presentation"
                        aria-hidden="true"
                        aria-label=""
                      >
                        <g>
                          <path
                            fill="#71C55D"
                            d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                            data-color="1"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <div>
                      <p>
                        Prepare for the unexpected. Recover from unintended
                        changes or misconfigurations with a few clicks.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        Get back on track quickly. Restore your entire
                        configuration or just the parts you need — no guesswork,
                        no delays.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div>
                      <div>
                        <svg
                          preserveAspectRatio="xMidYMid meet"
                          data-bbox="1.458 1.737 21.089 20.529"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="1.458 1.737 21.089 20.529"
                          height="24"
                          width="24"
                          data-type="color"
                          role="presentation"
                          aria-hidden="true"
                          aria-label=""
                        >
                          <g>
                            <path
                              fill="#71C55D"
                              d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                              data-color="1"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p>
                        Stay operational. Ensure business continuity without
                        scrambling for solutions.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* right section step 2 image */}
              <div className="first-left restore-sect">
                <img src={step2} alt="step-2" />
              </div>
              {/* right sectin step 3 content */}
              <div>
                <div className="warpping-both compply-alert">
                  <h5 className="missoon-head">Comply with confidence</h5>
                  <div className="network-idea">
                    <div className="d-flex">
                      <div>
                        <div>
                          <svg
                            preserveAspectRatio="xMidYMid meet"
                            data-bbox="1.458 1.737 21.089 20.529"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="1.458 1.737 21.089 20.529"
                            height="24"
                            width="24"
                            data-type="color"
                            role="presentation"
                            aria-hidden="true"
                            aria-label=""
                          >
                            <g>
                              <path
                                fill="#71C55D"
                                d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                                data-color="1"
                              ></path>
                            </g>
                          </svg>
                        </div>
                      </div>
                      <div>
                        <p>
                          Stay organized. Export your Meraki Dashboard
                          configuration for internal records and compliance.
                        </p>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div>
                        <div>
                          <svg
                            preserveAspectRatio="xMidYMid meet"
                            data-bbox="1.458 1.737 21.089 20.529"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="1.458 1.737 21.089 20.529"
                            height="24"
                            width="24"
                            data-type="color"
                            role="presentation"
                            aria-hidden="true"
                            aria-label=""
                          >
                            <g>
                              <path
                                fill="#71C55D"
                                d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                                data-color="1"
                              ></path>
                            </g>
                          </svg>
                        </div>
                      </div>
                      <div>
                        <p>
                          Simplify transitions. Ensure smooth project handovers
                          with as-built documentation.
                        </p>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div>
                        <div>
                          <svg
                            preserveAspectRatio="xMidYMid meet"
                            data-bbox="1.458 1.737 21.089 20.529"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="1.458 1.737 21.089 20.529"
                            height="24"
                            width="24"
                            data-type="color"
                            role="presentation"
                            aria-hidden="true"
                            aria-label=""
                          >
                            <g>
                              <path
                                fill="#71C55D"
                                d="M21.558 1.819c-.066.042-2.761 3.065-5.986 6.712s-5.934 6.675-6.014 6.722c-.136.085-.164.085-.328.024-.117-.043-.853-.685-2.232-1.936-1.832-1.674-2.085-1.89-2.404-2.04-.31-.145-.403-.168-.802-.182-.712-.028-1.167.136-1.645.59a2.4 2.4 0 0 0-.652 1.168c-.107.53.024 1.204.324 1.645.07.103 1.42 1.772 3.004 3.712 2.27 2.78 2.925 3.558 3.118 3.685.365.244.712.347 1.153.347.61 0 1.106-.207 1.523-.638.127-.126 2.424-3.783 5.958-9.473 3.164-5.1 5.803-9.357 5.864-9.46a.9.9 0 0 0 .108-.318c0-.202-.136-.455-.3-.554-.183-.112-.525-.117-.69-.004"
                                data-color="1"
                              ></path>
                            </g>
                          </svg>
                        </div>
                      </div>
                      <div>
                        <p>
                          Ensure compliance. Stay audit-ready and adhere to
                          company policies and industry regulations.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ----------------------------------bottom-page---------------------------------- */}
      <div className="container-fluid landing-page text-center ready-start">
        <div>
          <h2 className="last-count">
            <span>Ready to get started?</span>
          </h2>
          <div className="set-start">
            <button className="btn main-btn" type="button" onClick={() => { window.open("https://app.backupmeraki.com/register", "_blank", "noopener,noreferrer"); }}>
              Get Started
            </button>
          </div>
        </div>
      </div>
      {/* ------------------------------------------footer-------------------- */}
      {/* <div className="ftr-stared">
        <div className=" footer-div">
          <Footer />
        </div>
      </div> */}
    
    </> 
  );
};

export default MainBody;
